import { useCurrentSpace } from '@/hooks/useCurrentSpace.jsx'
import { useCurrentAccount } from '@/hooks/useCurrentAccount.jsx'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { RoleToWeight } from '@/consts/index.js'

// The 'level' could be 'account' or 'space', if non provided, will consider both and will take the higher one
export const useUserRole = (level) => {

    const { user } = useAuthContext()
    const { space } = useCurrentSpace()
    const { account } = useCurrentAccount()

    const userEntityInCurrentSpace = space.users.find(u => u.user === user._id)
    const userEntityInCurrentAccount = account.users.find(u => u.user === user._id)

    const userRoleInCurrentSpace = userEntityInCurrentSpace?.role
    const userRoleInCurrentAccount = userEntityInCurrentAccount?.role

    if (level === 'space') {
        return userRoleInCurrentSpace
    }

    if (level === 'account') {
        return userRoleInCurrentAccount
    }

    const spaceRoleWeight = userRoleInCurrentSpace ? RoleToWeight[userRoleInCurrentSpace] : 0
    const accountRoleWeight = userRoleInCurrentAccount ? RoleToWeight[userRoleInCurrentAccount] : 0

    if (spaceRoleWeight > accountRoleWeight) {
        return userRoleInCurrentSpace
    }

    if (spaceRoleWeight < accountRoleWeight) {
        return userRoleInCurrentAccount
    }

    return userRoleInCurrentAccount ? userRoleInCurrentAccount : userRoleInCurrentSpace
}